module.exports = __webpack_public_path__ + "img/more_square.2fcd3d89.svg";